import { useEffect, useState } from 'react';

export const loadModule = (name, module) => {
    return async () => {
        await __webpack_init_sharing__('default');
        const container = window[name];
        await container.init(__webpack_share_scopes__.default);

        const factory = await window[name].get(module);
        const Module = factory();
        return Module;
    };
};

export const openLiveChat = (bdId, bkColor) => {
    if (window._bcvmw) {
        const cacheTime = localStorage.getItem('_bc_chat_time') || 0;
        const time = +new Date();
        const cid = cacheTime > time ? localStorage.getItem('_bc_chat_cid') : undefined;
        window._bcvmw.chatWindow(
            {
                altText: '',
                bdid: bdId,
                element: '.bc-chat',
                embed: true,
                html: false,
                id: 'chat',
                img: 'https://aunclx-ssl.com/callchatter/beam/textbuttons/textbutton-1.png',
                launchType: 'embed',
                type: 'chat',
                video: false
            },
            cid
        );
        setTimeout(() => {
            const col1 = document.getElementsByClassName('bc-frame-header');
            if (document.getElementById('custom-css')) {
                return;
            } else {
                if (col1.length) {
                    col1[0].style.background = `${bkColor}`;
                    var style = document.createElement('style');
                    style.innerText = `.bc-frame-header:after { border-top: .5em solid ${bkColor}!important }`;
                    document.body.appendChild(style);
                    col1[0].setAttribute('id', 'custom-css');
                }
            }
        }, 3000);
    }
};

export const injectModuleScript = (name, url) => {
    const [ready, setReady] = useState(false);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = url;
        script.type = 'text/javascript';
        script.setAttribute('data-testid', `clx-${name}`);
        script.async = true;

        setReady(false);
        setFailed(false);

        script.onload = () => {
            setReady(true);
        };

        script.onerror = e => {
            console.error(`Error loading ${name} from: ${url}`);
            setReady(false);
            setFailed(false);
        };

        document.body.appendChild(script);
    }, [name, url]);

    return {
        ready,
        failed
    };
};
